import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import NotFoundPage from '../pages/NotFound';
import AboutPage from '../pages/about/page';
import ServicesPage from '../pages/services/page';
import PricingPage from '../pages/pricing/page';
import ContactPage from '../pages/contact/page';
import SignInPage from '../pages/auth/signin';
import SignUpPage from '../pages/auth/signup';
import AdminSignUpPage from '../pages/auth/admin-signup';
import MasterAdminLoginPage from '../pages/auth/master-admin-login';
import MasterAdminSignupPage from '../pages/auth/master-admin-signup';
import ResetPasswordPage from '../pages/auth/reset-password';
import ProviderSignupPage from '../pages/provider-signup/page';
import ServiceRequestPage from '../pages/service-request/page';
import ClientDashboardPage from '../pages/client-dashboard/page';
import ProviderDashboardPage from '../pages/provider-dashboard/page';
import AdminDashboardPage from '../pages/admin-dashboard/page';
import JobTrackingPage from '../pages/job-tracking/page';
import ProviderEarningsPage from '../pages/provider-earnings/page';
import AdminEarningsPage from '../pages/admin-earnings/page';
import LocationsPage from '../pages/locations/page';
import LocationPage from '../pages/location/page';
import LocationServicePage from '../pages/location-service/page';
import TradeJobsPage from '../pages/trade-jobs/page';
import TradeJobsCityPage from '../pages/trade-jobs-city/page';
import ProviderTermsPage from '../pages/provider-terms/page';
import PaymentPayoutPolicyPage from '../pages/payment-payout-policy/page';
import CancellationRefundPolicyPage from '../pages/cancellation-refund-policy/page';
import CustomerTermsPage from '../pages/customer-terms/page';
import ServiceCityPage from '../pages/service-city/page';
import ProviderVanAccessPage from '../pages/provider-van-access/page';
import ProviderApplyTradeSelectPage from '../pages/provider-apply-trade-select/page';
import ProviderApplyPage from '../pages/provider-apply/page';
import ProviderApplyPaymentPage from '../pages/provider-apply-payment/page';
import ProviderLogin from '../pages/auth/provider-login';

// Lazy loaded pages
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const ServicePlatformAlternatives = lazy(() => import('../pages/service-platform-alternatives/page'));
const CardiffPage = lazy(() => import('../pages/location-cardiff/page'));
const NewportPage = lazy(() => import('../pages/location-newport/page'));
const LocationNewportPage = lazy(() => import('../pages/location-newport/page'));
const LocationSwanseaPage = lazy(() => import('../pages/location-swansea/page'));
const LocationBristolPage = lazy(() => import('../pages/location-bristol/page'));
const LocationBirminghamPage = lazy(() => import('../pages/location-birmingham/page'));
const LocationManchesterPage = lazy(() => import('../pages/location-manchester/page'));
const LocationLiverpoolPage = lazy(() => import('../pages/location-liverpool/page'));
const LocationLeedsPage = lazy(() => import('../pages/location-leeds/page'));
const LocationNewcastlePage = lazy(() => import('../pages/location-newcastle/page'));
const LocationEdinburghPage = lazy(() => import('../pages/location-edinburgh/page'));
const LocationLondonPage = lazy(() => import('../pages/location-london/page'));
const LocationGlasgowPage = lazy(() => import('../pages/location-glasgow/page'));
const TestEmailPage = lazy(() => import('../pages/test-email/page'));
const ProviderApplyTradeSelectLazy = lazy(() => import('../pages/provider-apply-trade-select/page'));
const ProviderApplyLazy = lazy(() => import('../pages/provider-apply/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/signin',
    element: <SignInPage />,
  },
  {
    path: '/auth/signin',
    element: <SignInPage />,
  },
  {
    path: '/provider-login',
    element: <ProviderLogin />,
  },
  {
    path: '/auth/provider-login',
    element: <ProviderLogin />,
  },
  {
    path: '/auth/signup',
    element: <SignUpPage />,
  },
  {
    path: '/auth/admin-signup',
    element: <AdminSignUpPage />,
  },
  {
    path: '/auth/master-admin-login',
    element: <MasterAdminLoginPage />,
  },
  {
    path: '/auth/master-admin-signup',
    element: <MasterAdminSignupPage />,
  },
  {
    path: '/auth/reset-password',
    element: <ResetPasswordPage />,
  },
  {
    path: '/provider-signup',
    element: <ProviderSignupPage />,
  },
  {
    path: '/provider-dashboard',
    element: <ProviderDashboardPage />,
  },
  {
    path: '/provider-earnings',
    element: <ProviderEarningsPage />,
  },
  {
    path: '/provider/van-access/apply',
    element: <ProviderVanAccessPage />,
  },
  {
    path: '/provider/van-access/eligibility',
    element: <ProviderVanAccessPage />,
  },
  {
    path: '/provider/van-access/status',
    element: <ProviderVanAccessPage />,
  },
  {
    path: '/provider/van-access/manage',
    element: <ProviderVanAccessPage />,
  },
  {
    path: '/provider/van-access/payment',
    element: <ProviderVanAccessPage />,
  },
  {
    path: '/admin-dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/reports/earnings',
    element: <AdminEarningsPage />,
  },
  {
    path: '/client-dashboard',
    element: <ClientDashboardPage />,
  },
  {
    path: '/service-request',
    element: <ServiceRequestPage />,
  },
  {
    path: '/job-tracking/:jobId',
    element: <JobTrackingPage />,
  },
  {
    path: '/locations',
    element: <LocationsPage />,
  },
  {
    path: '/trade-jobs',
    element: <TradeJobsPage />
  },
  {
    path: '/trade-jobs-:city',
    element: <TradeJobsCityPage />
  },
  {
    path: '/provider-terms',
    element: <ProviderTermsPage />,
  },
  {
    path: '/payment-payout-policy',
    element: <PaymentPayoutPolicyPage />,
  },
  {
    path: '/cancellation-refund-policy',
    element: <CancellationRefundPolicyPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/customer-terms',
    element: <CustomerTermsPage />,
  },
  {
    path: '/service-platform-alternatives',
    element: <ServicePlatformAlternatives />
  },
  // Provider Application Routes - Trade Selection
  {
    path: '/providers/apply/select-trade',
    element: <ProviderApplyTradeSelectLazy />
  },
  // Provider Application Routes - Trade-Specific Forms
  {
    path: '/providers/apply/:trade',
    element: <ProviderApplyLazy />
  },
  // Provider Application Routes - Payment Page
  {
    path: '/provider-apply-payment',
    element: <ProviderApplyPaymentPage />
  },
  {
    path: '/providers/apply/:trade/payment',
    element: <ProviderApplyPaymentPage />
  },
  // City Landing Pages - MUST BE BEFORE dynamic routes
  {
    path: '/location-cardiff',
    element: <CardiffPage />,
  },
  {
    path: '/location-newport',
    element: <LocationNewportPage />
  },
  {
    path: '/location-swansea',
    element: <LocationSwanseaPage />
  },
  {
    path: '/location-bristol',
    element: <LocationBristolPage />
  },
  {
    path: '/location-birmingham',
    element: <LocationBirminghamPage />
  },
  {
    path: '/location-manchester',
    element: <LocationManchesterPage />
  },
  {
    path: '/location-liverpool',
    element: <LocationLiverpoolPage />
  },
  {
    path: '/location-leeds',
    element: <LocationLeedsPage />
  },
  {
    path: '/location-newcastle',
    element: <LocationNewcastlePage />
  },
  {
    path: '/location-edinburgh',
    element: <LocationEdinburghPage />,
  },
  {
    path: '/location-london',
    element: <LocationLondonPage />,
  },
  {
    path: '/location-glasgow',
    element: <LocationGlasgowPage />,
  },
  // Dynamic routes AFTER specific city pages
  {
    path: '/location/:city',
    element: <LocationPage />,
  },
  {
    path: '/location/:city/:service',
    element: <LocationServicePage />,
  },
  // Service-City Combination Routes - MUST BE AFTER specific routes
  {
    path: '/:serviceSlug-:citySlug',
    element: <ServiceCityPage />,
  },
  {
    path: '/test-email',
    element: <TestEmailPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
